import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
import _pt from "prop-types";
var _excluded = ["id", "innerRef", "type", "href", "custom", "preserveQuerystring", "className", "children"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.concat.js";
import * as React from 'react';
// The eternal debate! This component is not meant to be consumed directly, but is used as a base element in
// Button, Link, and IconButton.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var getTarget = function getTarget(preserveQueryParams, navTo) {
  if ((typeof window === 'undefined' || !preserveQueryParams) && !!navTo) {
    return navTo;
  }
  var locationSearch = window.location.search.split('?')[1];
  if (_typeof(navTo) === 'object') {
    var navToSearch = navTo.search ? "".concat(navTo.search, "&") : '';
    return _objectSpread(_objectSpread({}, navTo), {}, {
      search: "".concat(navToSearch).concat(locationSearch)
    });
  }
  return "".concat(navTo, "?").concat(locationSearch);
};
export var ButtonOrLink = function ButtonOrLink(_ref) {
  var id = _ref.id,
    innerRef = _ref.innerRef,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'button' : _ref$type,
    href = _ref.href,
    custom = _ref.custom,
    preserveQuerystring = _ref.preserveQuerystring,
    className = _ref.className,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  if (custom !== undefined && href !== undefined) {
    var Component = custom.component;
    var targetProp = _defineProperty({}, custom.mapHrefToProp || 'href', getTarget(preserveQuerystring, href));
    return /*#__PURE__*/React.createElement(Component, _extends({
      id: id,
      className: className
    }, targetProp, rest, {
      ref: innerRef
    }), children);
  }
  if (href !== undefined) {
    return /*#__PURE__*/React.createElement("a", _extends({
      id: id,
      ref: innerRef,
      href: getTarget(preserveQuerystring, href),
      className: className
    }, rest), children);
  }
  return /*#__PURE__*/React.createElement("button", _extends({
    type: type,
    id: id,
    ref: innerRef,
    className: className
  }, rest), children);
};
ButtonOrLink.propTypes = {
  /** Add an optional ID to either of these elements: `<a>` or `<button>`. */id: _pt.string,
  /** Add custom classes to either of these elements: `<a>` or `<button>`. */className: _pt.string,
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any*/
  /** If you want to render a custom component, such as the Link component from react-router, you pass it in through
     * this property. Addtionally if the target prop name isn't href you must specify the name in mapHrefToProp.
     * In the case of react-router-dom you would set the value to 'to' */
  custom: _pt.shape({
    component: _pt.any,
    mapHrefToProp: _pt.string
  }),
  /**
     * Set the button type, if necessary. Use 'submit' for a form submit button,
     * and 'reset' within forms to reset inputs.
     * @default 'button'
     */
  type: _pt.oneOf(['button', 'submit', 'reset']),
  /** Preserve the query string parameters for the current page */preserveQuerystring: _pt.bool,
  /** Set an href to generate an anchor. */href: _pt.string,
  /** Input children to either of these elements: `<a>` or `<button>`. */children: _pt.node
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/lmds-react-button-or-link/dist/_esm/ButtonOrLink.js
// module id = 2507
// module chunks = 0